import { Suspense, lazy } from "react";
import "@/App.css";
import { BrowserRouter, Route, Routes } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import ClerkAuthProvider from "@/components/auth/ClerkAuthProvider";
import { StoreProvider } from "@/context/StoreContext";
import { LocalAuthProvider } from "@/context/AuthContext";
import StoreLayout from "@/components/store/StoreLayout";
import Home from "@/pages/store/Home";

const Catalog = lazy(() => import("@/pages/store/Catalog"));
const ProductPage = lazy(() => import("@/pages/store/ProductPage"));
const CartPage = lazy(() => import("@/pages/store/CartPage"));
const Checkout = lazy(() => import("@/pages/store/Checkout"));
const TestPayment = lazy(() => import("@/pages/store/OrderPages").then((m) => ({ default: m.TestPayment })));
const OrderView = lazy(() => import("@/pages/store/OrderPages").then((m) => ({ default: m.OrderView })));
const AccountPage = lazy(() => import("@/pages/store/Account").then((m) => ({ default: m.AccountPage })));
const SignInPage = lazy(() => import("@/pages/store/Account").then((m) => ({ default: m.SignInPage })));
const SignUpPage = lazy(() => import("@/pages/store/Account").then((m) => ({ default: m.SignUpPage })));
const AdminLayout = lazy(() => import("@/pages/admin/AdminLayout"));
const Dashboard = lazy(() => import("@/pages/admin/Dashboard"));
const Orders = lazy(() => import("@/pages/admin/Orders"));
const Products = lazy(() => import("@/pages/admin/Products"));
const Customers = lazy(() => import("@/pages/admin/Customers"));
const Campaigns = lazy(() => import("@/pages/admin/Campaigns"));
const Migration = lazy(() => import("@/pages/admin/Migration"));
const Integrations = lazy(() => import("@/pages/admin/Integrations"));
const Settings = lazy(() => import("@/pages/admin/Settings"));
const Staff = lazy(() => import("@/pages/admin/Staff"));
const Geo = lazy(() => import("@/pages/admin/Geo"));
const Logs = lazy(() => import("@/pages/admin/Logs"));

const NotFound = () => <div className="container-x py-24 text-center"><h1 className="text-4xl">Sayfa bulunamadı</h1></div>;
const Auth = (n) => lazy(() => import("@/pages/store/AuthLocal").then((m) => ({ default: m[n] })));
const Info = (n) => lazy(() => import("@/pages/store/InfoPages").then((m) => ({ default: m[n] })));
const LoginPage = Auth("LoginPage");
const RegisterPage = Auth("RegisterPage");
const ForgotPage = Auth("ForgotPage");
const StaticPage = Info("StaticPage");
const BanksPage = Info("BanksPage");
const ContactPage = Info("ContactPage");
const BlogList = Info("BlogList");
const BlogPost = Info("BlogPost");
const Reports = lazy(() => import("@/pages/admin/Reports"));
const Content = lazy(() => import("@/pages/admin/Content"));

function App() {
  return (
    <BrowserRouter>
      <LocalAuthProvider>
      <ClerkAuthProvider>
        <StoreProvider>
          <Suspense fallback={<div className="min-h-screen" />}>
            <Routes>
              <Route element={<StoreLayout />}>
                <Route path="/" element={<Home />} />
                <Route path="/urunler" element={<Catalog />} />
                <Route path="/kategori/:slug" element={<Catalog />} />
                <Route path="/urun/:slug" element={<ProductPage />} />
                <Route path="/sepet" element={<CartPage />} />
                <Route path="/odeme" element={<Checkout />} />
                <Route path="/odeme/test/:no" element={<TestPayment />} />
                <Route path="/siparis/:no" element={<OrderView />} />
                <Route path="/hesabim" element={<AccountPage />} />
                <Route path="/sign-in/*" element={<SignInPage />} />
                <Route path="/sign-up/*" element={<SignUpPage />} />
                <Route path="/giris" element={<LoginPage />} />
                <Route path="/kayit" element={<RegisterPage />} />
                <Route path="/sifremi-unuttum" element={<ForgotPage />} />
                <Route path="/hakkimizda" element={<StaticPage slug="hakkimizda" />} />
                <Route path="/cerez-politikasi" element={<StaticPage slug="cerez-politikasi" />} />
                <Route path="/sayfa/:slug" element={<StaticPage />} />
                <Route path="/banka-hesaplari" element={<BanksPage />} />
                <Route path="/iletisim" element={<ContactPage />} />
                <Route path="/blog" element={<BlogList />} />
                <Route path="/blog/:slug" element={<BlogPost />} />
                <Route path="*" element={<NotFound />} />
              </Route>
              <Route path="/yonetim" element={<AdminLayout />}>
                <Route index element={<Dashboard />} />
                <Route path="siparisler" element={<Orders />} />
                <Route path="urunler" element={<Products />} />
                <Route path="musteriler" element={<Customers />} />
                <Route path="kampanyalar" element={<Campaigns />} />
                <Route path="veri-aktarimi" element={<Migration />} />
                <Route path="entegrasyonlar" element={<Integrations />} />
                <Route path="ayarlar" element={<Settings />} />
                <Route path="personel" element={<Staff />} />
                <Route path="cografya" element={<Geo />} />
                <Route path="bildirimler" element={<Logs />} />
                <Route path="raporlar" element={<Reports />} />
                <Route path="icerik" element={<Content />} />
              </Route>
            </Routes>
          </Suspense>
          <Toaster position="top-center" richColors />
        </StoreProvider>
      </ClerkAuthProvider>
      </LocalAuthProvider>
    </BrowserRouter>
  );
}

export default App;
